// extracted by mini-css-extract-plugin
module.exports = {"Warning-cookie-banner-wrapper":"warning-cookie-banner-wrapper_Warning-cookie-banner-wrapper__qry0T"};